module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-color-white"
  }, [_c('div', {
    staticClass: "fixed",
    class: {
      'fixed-shadow': _vm.suspension
    }
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-width"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v(_vm._s(_vm.headerName))])], 1), _vm._v(" "), _c('ul', {
    staticClass: "main-top-info"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Center'
      }
    }
  }, [_vm._v(_vm._s(_vm.account))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Order'
      }
    }
  }, [_c('i', {
    staticClass: "header-order-icon"
  }), _vm._v("订单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Wallet'
      }
    }
  }, [_c('i', {
    staticClass: "header-order-icon header-wallet-icon"
  }), _vm._v("我的钱包")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "border": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Document'
      }
    }
  }, [_c('i', {
    staticClass: "header-order-icon header-document-icon"
  }), _vm._v("功能文档")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5002c19f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topHeader.vue
// module id = 532
// module chunks = 1